import DataApi from './DataApi';
import * as constants from '../constants/CONSTANT';

const TELECMI_API_PREFIX = `${constants.API_BASE_URL}/api/telecmi`;

function redactTelecmiPayload(payload) {
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
    return payload;
  }
  const out = { ...payload };
  if ('password' in out) out.password = '***redacted***';
  if ('secret' in out) out.secret = '***redacted***';
  if (out.user_token != null && String(out.user_token).trim() !== '') {
    const t = String(out.user_token);
    out.user_token =
      t.length > 24 ? `${t.slice(0, 14)}…${t.slice(-10)}` : '***redacted***';
  }
  if (out.token != null && String(out.token).trim() !== '') {
    const t = String(out.token);
    out.token =
      t.length > 24 ? `${t.slice(0, 14)}…${t.slice(-10)}` : '***redacted***';
  }
  return out;
}

function logTelecmiRequest(method, path, payload) {
  const url = `${TELECMI_API_PREFIX}${path}`;
  const line = {
    method,
    url,
    ...(payload !== undefined
      ? { body: redactTelecmiPayload(payload) }
      : {}),
  };
  console.log('[TelecmiApi] outgoing request', line);
}

class TelecmiApi {
  constructor() {
    this.api = new DataApi('telecmi');
  }

  initiateCall(payload) {
    logTelecmiRequest('POST', '/initiate', payload);
    return this.api.post('/initiate', payload);
  }

  /** POST /v2/user/login via backend proxy */
  userLogin(payload) {
    logTelecmiRequest('POST', '/user/login', payload);
    return this.api.post('/user/login', payload);
  }

  /** SBC logout via backend proxy */
  userLogout(payload) {
    logTelecmiRequest('POST', '/user/logout', payload);
    return this.api.post('/user/logout', payload);
  }

  fetchSettings() {
    logTelecmiRequest('GET', '/settings');
    return this.api.get('/settings');
  }

  saveSettings(data) {
    logTelecmiRequest('PUT', '/settings', data);
    return this.api.put('/settings', data);
  }

  /** POST TeleCMI /v2/c2c/hangup via backend (body: token, cmiuuid) */
  c2cHangup(payload) {
    logTelecmiRequest('POST', '/c2c/hangup', payload);
    return this.api.post('/c2c/hangup', payload);
  }
}

const telecmiApi = new TelecmiApi();
export default telecmiApi;
